import FormFieldset from '../FormFieldset';
import FormLegend from '../FormLegend';
import FormHint from '../FormHint';
import FormCheckbox from '../FormCheckbox';
import { trackFilterSelection } from '../../utils/dataLayer';

export default function MultiCheckboxFilter(props) {
  const fieldId = props.fieldId;
  const facets = props.facets;
  const filters = props.filters;
  const filter = filters
    ? filters?.find(filter => filter.field === fieldId)
    : undefined;
  let options =
    facets[fieldId] && facets[fieldId].length > 0
      ? facets[fieldId][0].data
      : [];

  if (props.orderByCount) {
    options = [...options].sort((a, b) => b.count - a.count);
  }

  if (filter) {
    options.map(
      option => (option.selected = filter.values.includes(option.value)),
    );
  }

  const toggleChange = value => {
    if (!filter?.values.includes(value)) {
      props.addFilter(props.fieldId, value, 'any');
      trackFilterSelection(props.fieldId, value);
    } else {
      props.removeFilter(props.fieldId, value, 'any');
    }
  };

  return (
    <FormFieldset aria-describedby={`${props.id}-hint`}>
      <FormLegend hasHint={props.formHint}>{props.label}</FormLegend>

      {(props.formHint || options.length === 0) && (
        <FormHint id={`${props.id}-hint`}>
          {options.length === 0 ? 'No matching records' : props.formHint}
        </FormHint>
      )}

      <div>
        {options.map((option, index) => {
          return (
            <FormCheckbox
              checked={option.selected}
              data-transaction-name="facet - "
              id={'facet_' + option.value}
              key={index}
              label={`${option.value} (${option.count.toLocaleString()})`}
              onChange={() => toggleChange(option.value)}
              type="checkbox"
              value={option.value}
            />
          );
        })}
      </div>
    </FormFieldset>
  );
}
